import React, { useState } from "react";
import Table from "react-bootstrap/Table";
import _ from "lodash";
import * as setOffSelectors from "../../../../selectors/set-off";
import { getSetOffTransactionText } from "../../../../selectors/set-off";
import clsx from "clsx";

function PaymentContractsItem({data}) {

  const [buttonShow, setButtonShow] = useState(false);
  const limitedItems = 10;
  const listingFilter = buttonShow ? data : _.slice(data, 0, limitedItems);

  return <div style={{marginBottom:"2rem"}}>
    <div className=" deposit-form-title position-relative">
      <p className="payment-detail-title text-bold-600 mb-0">Contracts Info</p>

    </div>
    <div className={"responsive-table-border payment-table"}>
      <Table responsive="lg" className="payment-detail-table-table">
        <thead>
        <tr className={"custom-table-setoff-styled payment-detail-table"}>
          <th style={{ width: 100 }}>Reference No</th>
          <th style={{ width: 120 }}>Stock Code</th>
          <th style={{ width: 120 }}>Stock Name</th>
          <th style={{ width: 140 }}>Date</th>
          <th style={{ width: 180 }}>Payment Amount</th>
        </tr>
        {_.map(listingFilter, (contract, index)=>{
          const contractReference = setOffSelectors.getSetOffContractReference(contract);
          const stockCode = setOffSelectors.getSetOffStockCode(contract);
          const stockName = setOffSelectors.getSetOffStockName(contract);
          const paymentText = setOffSelectors.getSetOffPaymentText(contract);
          // const stockName = setOffSelectors.getSetOffStockName(contract);
          const transactionText =
            setOffSelectors.getSetOffTransactionText(contract);
          return (
              <tr key={index}>
                <td>{contractReference}</td>
                <td>{stockCode ?? '-'}</td>
                <td>{stockName ?? '-'}</td>
                <td>{transactionText}</td>
                <td>{paymentText}</td>
              </tr>
          );
        })}
        </thead>
      </Table>
    </div>

    {_.size(data) > limitedItems && (
        <div style={{ textAlign: "center", marginTop: "1rem" }}>
          <button
              className={clsx("btn custom-button-primary")}
              style={{ backgroundColor: "#9D7905" }}
              onClick={() => setButtonShow(!buttonShow)}
          >
            {buttonShow ? "View Less" : "View More"}
          </button>
        </div>
    )}
  </div>
}

export default PaymentContractsItem;